import {AdminVI} from "./admin/vi";

export const SystemVI = {
    ...AdminVI
}